import { Box, Text } from '@mantine/core';
import moment from 'moment';

import { Batch, BatchTraceActionEnum, EORIGIN_DATE_FORMAT_WITH_TIME } from '@e-origin/shared';

import { StatisticLink, TableColumnProps } from '@components';
import { useBatchModalManager } from '../batchModalManager';

const ADDITIONAL_COLUMNS_STYLES = {
  backgroundColor: '#F4F9FF',
};

export const useBuildInformationColumns = (): Record<string, TableColumnProps<Batch>[]> => {
  const batchModalManager = useBatchModalManager();

  return {
    batchName: [
      {
        name: 'Batch name',
        selector: 'name',
        sortable: true,
        cell: (row) => <div data-pw={`cell-name-${row.name}`}>{row.name}</div>,
        style: ADDITIONAL_COLUMNS_STYLES,
      },
    ],
    customer: [
      {
        name: 'Customer',
        cell: (row) => (row.virtuals as any)?.customerName || '',
        style: ADDITIONAL_COLUMNS_STYLES,
      },
    ],
    fileName: [
      {
        name: 'File name',
        selector: 'filename',
        sortable: true,
        cell: (row) => (
          <Box w="250">
            <Text truncate="end" size="sm" data-pw={`cell-filename-${row.name}`}>
              {row.filename}
            </Text>
          </Box>
        ),
        style: ADDITIONAL_COLUMNS_STYLES,
      },
    ],
    templateName: [
      {
        name: 'Template name',
        cell: (row) => (row.virtuals as any)?.templateName || '',
        style: ADDITIONAL_COLUMNS_STYLES,
      },
    ],
    date: [
      {
        name: 'Date',
        cell: (row) => moment(row.updatedAt).format(EORIGIN_DATE_FORMAT_WITH_TIME),
        selector: 'updatedAt',
        sortable: true,
        style: ADDITIONAL_COLUMNS_STYLES,
      },
    ],
    numberOfUpdates: [
      {
        name: 'Number of updates',
        cell: (row) => (
          <StatisticLink
            onClick={() => {
              if (row.trace?.length > 0) batchModalManager.openBatchAudit({ batch: row });
            }}
          >
            {row.trace.filter((trace) => trace.action === BatchTraceActionEnum.UPDATE).length || 0}
          </StatisticLink>
        ),
        style: ADDITIONAL_COLUMNS_STYLES,
      },
    ],
  };
};
